document.addEventListener('DOMContentLoaded', () => {
  const LOCAL_STORAGE_KEY = 'huesnvines_wishlist';
  
  function getWishlist() {
    try {
      const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(wishlist) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(wishlist));
  }

  function toggleWishlistItem(handle) {
    let wishlist = getWishlist();
    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
    } else {
      wishlist.push(handle);
    }
    saveWishlist(wishlist);
    updateButtons();
  }

  function updateWishlistCount() {
    const wishlist = getWishlist();
    const countBubble = document.getElementById('wishlist-count-bubble');
    if (countBubble) {
      if (wishlist.length > 0) {
        countBubble.classList.remove('hidden');
        countBubble.style.display = 'flex';
        const spans = countBubble.querySelectorAll('span');
        if (spans.length >= 2) {
          spans[0].textContent = wishlist.length;
          spans[1].textContent = `${wishlist.length} items`;
        }
      } else {
        countBubble.classList.add('hidden');
        countBubble.style.display = 'none';
      }
    }
  }

  function updateButtons() {
    const wishlist = getWishlist();
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      if (wishlist.includes(handle)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
    updateWishlistCount();
  }

  // Event delegation for wishlist buttons
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('.wishlist-btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.getAttribute('data-product-handle');
      if (handle) {
        toggleWishlistItem(handle);
        
        // If we are on the wishlist page and removing an item, remove the card visually
        const wishlistContainer = document.querySelector('[data-wishlist-container]');
        if (wishlistContainer && !btn.classList.contains('active')) {
          const card = btn.closest('.grid__item') || btn.closest('.card-wrapper')?.parentElement;
          if (card) {
            card.remove();
            checkEmptyState();
          }
        }
      }
    }
  });

  // Initial button state setup
  updateButtons();

  // Wishlist page logic
  const wishlistContainer = document.querySelector('[data-wishlist-container]');
  
  function checkEmptyState() {
    if (!wishlistContainer) return;
    const wishlist = getWishlist();
    const grid = wishlistContainer.querySelector('[data-wishlist-grid]');
    const emptyState = wishlistContainer.querySelector('[data-wishlist-empty]');
    if (wishlist.length === 0) {
      grid.style.display = 'none';
      emptyState.classList.remove('hidden');
    } else {
      grid.style.display = '';
      emptyState.classList.add('hidden');
    }
  }

  if (wishlistContainer) {
    const grid = wishlistContainer.querySelector('[data-wishlist-grid]');
    const loadingState = wishlistContainer.querySelector('[data-wishlist-loading]');

    async function loadWishlistItems() {
      const wishlist = getWishlist();
      if (wishlist.length === 0) {
        loadingState.style.display = 'none';
        checkEmptyState();
        return;
      }

      const fetchPromises = wishlist.map(handle => 
        fetch(`/products/${handle}?view=card`)
          .then(res => {
            if (!res.ok) throw new Error('Product not found');
            return res.text();
          })
          .catch(e => {
            console.error('Error fetching product:', handle, e);
            return null;
          })
      );

      const productHTMLs = await Promise.all(fetchPromises);
      
      let html = '';
      productHTMLs.forEach(cardHTML => {
        if (cardHTML) {
           html += `<li class="grid__item">${cardHTML}</li>`;
        }
      });

      grid.innerHTML = html;
      loadingState.style.display = 'none';
      checkEmptyState();
      updateButtons(); 
    }

    loadWishlistItems();
  }
});
